import { Component, Inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
} from '@angular/material/dialog';
import { PackageContent, TechnicalAttribute } from '../../../services/products.service';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../services/app.service';
import { NgIf } from '@angular/common';

export interface ProductDetailsDialogData {
    description: string;
    technicalAttributes: TechnicalAttribute[];
    packageContents: PackageContent[];
}

@Component({
    selector: 'app-product-details-dialog',
    standalone: true,
    imports: [
        MatDialogClose,
        MatIcon,
        MatIconButton,
        TranslateModule,
        MatDialogContent,
        MatButton,
        MatDialogActions,
        NgIf,
    ],
    templateUrl: './product-details-dialog.component.html',
    styleUrl: './product-details-dialog.component.scss',
})
export class ProductDetailsDialogComponent {
    constructor(
        public translate: TranslateService,
        public appService: AppService,
        public dialogRef: MatDialogRef<ProductDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ProductDetailsDialogData
    ) {}

    public formatDecimalComma(value: number): string {
        return value.toLocaleString(`${this.appService.getLanguageOnly()}-${this.appService.getLocation()}`);
    }
}
